import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import { toggleClass } from '../utils/dom'
import scrollToElement from '../services/Viewport/scrollToElement'

export const STATES = {
    COMPLETED: 'is-completed',
    HIDDEN: 'is-hidden',
    WINNER: 'is-winner'
}

export default class CourseProgress extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            lesson: null,
            star: null
        }
    }

    prepare() {
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)
    }

    handleStateChange = state => {
        this.render(state, true)
    }

    show() {
        this.element.classList.remove(STATES.HIDDEN)
    }

    hide() {
        this.element.classList.add(STATES.HIDDEN)
    }

    render(state, withScroll = false) {
        const lessons = Object.entries(state.lessons)
        const count = lessons.length
        const completed = lessons
            .map(entry => entry[1])
            .reduce((acc, lesson) => acc + (lesson.completed ? 1 : 0), 0)

        const completedSetCount = Object.entries(state.sets)
            .filter(([key, data]) => data.completed)
            .length

        const stars = CourseState.getStarCount()

        const lessonProgress = Component.getFromElement(this.ref.lesson)
        lessonProgress.update({
            current: completed,
            total: count
        })

        const starProgress = Component.getFromElement(this.ref.star)
        starProgress.update({
            current: stars,
            total: count * 3
        })

        const level = CourseState.getLevel()

        toggleClass(this.element, STATES.HIDDEN, completed === 0)
        toggleClass(this.element, STATES.COMPLETED, completed === count)
        toggleClass(this.element, 'is-setLevel-1', completedSetCount === 1)
        toggleClass(this.element, 'is-setLevel-2', completedSetCount === 2)
        toggleClass(this.element, 'is-setLevel-3', completedSetCount > 2 && completed !== count)
        toggleClass(this.element, 'is-level-4', level === 4)
        toggleClass(this.element, 'is-level-3', level === 3)
        toggleClass(this.element, 'is-level-2', level === 2)
        toggleClass(this.element, 'is-level-1', level === 1)
        toggleClass(this.element, 'is-level-0', level === 0)

        if (CourseState.hasAllStars && withScroll) {
            setTimeout(() => {
                scrollToElement(document.getElementById('hero-visual'), 80)
                setTimeout(() => {
                    toggleClass(this.element, STATES.WINNER, CourseState.hasAllStars)
                }, 1000)
            }, 500)
        }
    }

}
